export default {
	TOTEM_NAVIGATION_COMMUNICATIONS: 'Communications',
	TOTEM_NAVIGATION_DOCUMENTS: 'Documents',

	TOTEM_HEADER_DOCUMENTS_TITLE: 'Public Documents',
	TOTEM_HEADER_NEWS_TITLE: 'Public Communications',

	TOTEM_CARD_FOLDER_UP: 'Previous folder',
	TOTEM_CARD_FOLDER_TYPE: 'Folder'
};
